import { AuthCallback, RequireAuth } from '@nrx/auth-ui';
import type { JSX } from 'react';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { FileExchangePage } from './file-exchange-page.js';

const servicesBaseUrl = (import.meta.env['VITE_SERVICES_BASE_URL'] as string | undefined) ?? '';

const router = createBrowserRouter([
  {
    path: '/auth/callback',
    element: <AuthCallback />,
  },
  {
    path: '/',
    element: <RequireAuth />,
    children: [
      {
        path: '*',
        element: <FileExchangePage servicesBaseUrl={servicesBaseUrl} />,
      },
      {
        index: true,
        element: <FileExchangePage servicesBaseUrl={servicesBaseUrl} />,
      },
    ],
  },
]);

export function App(): JSX.Element {
  return <RouterProvider router={router} />;
}
